import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import IpraSimulador from "./pages/simulador";
import NotFoundPage from "./pages/404NotFound";

function AppRoutes() {
    return (
        <>
            <Router>
                <Routes >
                    <Route path="/" element={<IpraSimulador />} exact />
                    <Route path="*" element={<NotFoundPage />} exact />
                </Routes>
            </Router>
        </>
    )
}

export default AppRoutes;
